(function () {
  'use strict';

  window._learnq = window._learnq || [];

  function track(name, props) {
    window._learnq.push(['track', name, props || {}]);
  }

  function productMeta() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta && meta.product ? meta.product : null;
  }

  function moneyToFloat(cents) {
    var n = Number(cents);
    if (!n) return 0;
    return n > 1000 ? n / 100 : n;
  }

  function trackViewedProduct() {
    if (!document.body.classList.contains('template-product')) return;
    var p = productMeta();
    if (!p) return;

    var price = moneyToFloat(p.price);
    track('Viewed Product', {
      ProductID: p.id,
      Name: p.title || document.title,
      Brand: 'InnerUnion',
      URL: window.location.href,
      ImageURL: p.image || '',
      $value: price,
      Price: price,
      Source: 'theme_behavioral',
    });
  }

  function trackAddedToCart(variantId, quantity, product) {
    var p = product || productMeta() || {};
    var price = moneyToFloat(p.price);
    var qty = Number(quantity) || 1;

    track('Added to Cart', {
      ProductID: String(p.id || ''),
      VariantID: String(variantId || ''),
      'Product Name': p.title || '',
      Brand: 'InnerUnion',
      URL: window.location.href,
      ImageURL: p.image || '',
      Quantity: qty,
      Price: price,
      $value: price * qty,
      $currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      Source: 'theme_behavioral',
    });
  }

  function parseCartAddBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    if (body instanceof FormData) {
      return { id: body.get('id'), quantity: body.get('quantity') || 1 };
    }
    return null;
  }

  function hookFetch() {
    if (!window.fetch || window.__iuhKlaviyoFetchHooked) return;
    window.__iuhKlaviyoFetchHooked = true;
    var original = window.fetch;
    window.fetch = function (url, options) {
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      if (href.indexOf('/cart/add') !== -1) {
        var data = options && parseCartAddBody(options.body);
        if (data && data.id) {
          trackAddedToCart(data.id, data.quantity || 1);
        }
      }
      return original.apply(this, arguments);
    };
  }

  function hookForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (idInput && idInput.value) {
        trackAddedToCart(idInput.value, qtyInput ? qtyInput.value : 1);
      }
    }, true);
  }

  function trackCheckoutStarted() {
    if (window.location.pathname.indexOf('/checkouts') === -1 &&
        window.location.pathname.indexOf('/checkout') === -1) {
      return;
    }
    if (window.__iuhKlaviyoCheckoutTracked) return;
    window.__iuhKlaviyoCheckoutTracked = true;
    track('Checkout Started', {
      $value: 0,
      Source: 'theme_behavioral',
      URL: window.location.href,
    });
  }

  function hookCheckoutClicks() {
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el) return;
      var link = el.closest && el.closest('a[href*="/checkout"], button[name="checkout"], [href*="checkout"]');
      if (link) {
        track('Checkout Started', {
          $value: 0,
          Source: 'theme_behavioral',
          URL: window.location.href,
        });
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackViewedProduct);
  } else {
    trackViewedProduct();
  }

  hookFetch();
  hookForms();
  hookCheckoutClicks();
  trackCheckoutStarted();
})();
